const About = props => {
  return (
    <section id="about">
      <div className="wrapper">
        <article>
          <div className="title">
            <h3>Who's this guy?</h3>
            <p className="separator" />
          </div>
          <div className="desc full">
            <h4 className="subtitle">My name is Amanuel(Emanuel).</h4>
            <p>
              I love to solve problems and improve the world 😉
            </p>
            <p>
              I'm well qualified a Full Stack Developer familiar with a wide range of programming utilities and languages. Knowledgeable of backend and frontend development requirements. Handles any part of the process with ease. Collaborative team player with excellent technical abilities offering 2 years of related experience.
            </p>
          </div>
          <div className="title">
            <h3>What does I do?</h3>
            <p className="separator" />
          </div>
          <div className="desc">
            <h4 className="subtitle">Back-end Technologies</h4>
            <p>
              I love to work to backing and bring invisible to visible👨‍💻
            </p>

            <div className="tech-continuer">
              <div className="tech-item">NestJs</div>
              <div className="tech-item">Nodejs</div>
              <div className="tech-item">Express</div>
              <div className="tech-item">MongoDB</div>
              <div className="tech-item">MySQL</div>
              <div className="tech-item">PostgreSQL</div>
              <div className="tech-item">MySQL</div>
              <div className="tech-item">Firebase</div>
            </div>

          </div>
          <div className="desc">
            <h4 className="subtitle">Front-end Technologies</h4>
            <p>
              I like to code things from scratch, and enjoy bringing ideas to life in the browser.🏖️
            </p>

            <div className="tech-continuer">
              <div className="tech-item">ReactJs</div>
              <div className="tech-item">NextJs</div>
              <div className="tech-item">TypeScript</div>
             
              <div className="tech-item">Tailwind</div>
              <div className="tech-item">Redux</div>
              <div className="tech-item">Flutter</div>
              <div className="tech-item">Getx</div>
              <div className="tech-item">Flutter</div>
              <div className="tech-item">JavaScript</div>
              <div className="tech-item">Material-UI</div>
             
            </div>

          </div>
          <div className="desc">
            <h4 className="subtitle">Tools</h4>
            <p>
            choose tools to be more productive and efficient🏗️
            </p>

            <div className="tech-continuer">
              <div className="tech-item">GitHub</div>
             
              <div className="tech-item">Figma</div>
              <div className="tech-item">Adobe XD</div>
              <div className="tech-item">Trello</div>
              
              <div className="tech-item">Postman</div>
              <div className="tech-item">Insomnia</div>
              <div className="tech-item">Microsoft Todo</div>
              <div className="tech-item">Vscode💚</div>
            </div>

          </div>

        </article>
      </div>
    </section>
  );
};

export default About;  